module.exports = "<div class=\"container\">\r\n    <img src=\"./assets/img/success.svg\">\r\n    <span>{{'success' | translate}}</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/betting/success/success.component.html
// module id = ../../../../../src/app/betting/success/success.component.html
// module chunks = 1